class FAQ
{

	constructor(container)
	{
		this.container = container;
		if (!this.container) return;
		this.init();
	}

	init()
	{
		this.container.querySelectorAll('.faqs__question').forEach(question => {
			question.addEventListener('click', this.FAQExpansion); // Event passed automatically in this instance
			question.addEventListener('keydown', (event) => {
				if (event.key === 'Enter' || event.key === ' ') {
					event.preventDefault(); // Prevent scrolling on Space
					this.FAQExpansion(event); // Passes event
				}
			});
		});
	}

	FAQExpansion(event)
	{
		const question = event.currentTarget;
		const item = question.closest('.faqs__item');
		const answer = item.querySelector('.faqs__answer');
		const isOpen = item.classList.contains('faqs__item--open');
		const answerHeight = answer.scrollHeight;

		if (isOpen) {
			// Collapse
			answer.style.height = `${answerHeight}px`; // From
			answer.offsetHeight;
			answer.style.height = '0px'; // To
    } else {
			// Expand
			answer.style.height = '0px'; // From
			answer.offsetHeight;
			answer.style.height = `${answerHeight}px`; // To
    }

    // Toggle class and ARIA
		item.classList.toggle('faqs__item--open');
    question.setAttribute('aria-expanded', !isOpen);
    answer.setAttribute('aria-hidden', isOpen);

    // Clean up after transition
    answer.addEventListener('transitionend', () => {
			if (!item.classList.contains('faqs__item--open')) {
					answer.style.height = '';
			} else {
					answer.style.height = 'auto';
			}
    }, { once: true });
	}

}

document.querySelectorAll('.faqs').forEach(container => {
  new FAQ(container);
});